module.exports = __webpack_public_path__ + "img/55.82494711.svg";